import {
    useVrboCreateCancellationPolicyMutation,
    useVrboReplaceCancellationPolicyMutation,
    useVrboUpdatePropertyAvailabilityMutation,
    useVrboUpdatePropertyPricingMutation,
} from "../../../services/bClientApi";
import useVrboAction from "../useVrboAction";
import VrboActionRow from "../VrboActionRow";

export default function VrboRatesSection(
    props: {
        propertyId: string
        integrationData: any
    }
) {
    const { propertyId, integrationData } = props

    const [updatePricing] = useVrboUpdatePropertyPricingMutation()
    const [updateAvailability] = useVrboUpdatePropertyAvailabilityMutation()
    const [createCancellationPolicy] = useVrboCreateCancellationPolicyMutation()
    const [replaceCancellationPolicy] = useVrboReplaceCancellationPolicyMutation()

    const cancellationPolicies = integrationData?.rawData?.policies?.cancellationPolicyConfigsPaginated?.elements
    const hasCancellationPolicy = !!cancellationPolicies?.length
    const cancellationPolicyId: string | undefined = cancellationPolicies?.[0]?.id

    const enabled = !!propertyId

    // pricing and availability responses come back as JSON strings
    const pricing = useVrboAction(
        () => updatePricing(propertyId).unwrap(),
        { errorLabel: 'updating VRBO property pricing', parse: JSON.parse, enabled },
    )
    const availability = useVrboAction(
        () => updateAvailability(propertyId).unwrap(),
        { errorLabel: 'updating VRBO property availability', parse: JSON.parse, enabled },
    )

    // create and replace share one result slot, as the button swaps based on the policy state
    const cancellationPolicy = useVrboAction(
        () => hasCancellationPolicy
            ? replaceCancellationPolicy(cancellationPolicyId as string).unwrap()
            : createCancellationPolicy(propertyId).unwrap(),
        {
            errorLabel: hasCancellationPolicy ? 'replacing VRBO cancellation policy' : 'creating VRBO cancellation policy',
            enabled: hasCancellationPolicy ? !!cancellationPolicyId : enabled,
        },
    )

    return (
        <div>
            <VrboActionRow action={pricing} label="Update Property Pricing" busyLabel="Updating..." resultTitle="Update Property Pricing Response" />
            <VrboActionRow action={availability} label="Update Property Availability" busyLabel="Updating..." resultTitle="Update Property Availability Response" />
            {hasCancellationPolicy ? (
                <VrboActionRow
                    action={cancellationPolicy}
                    label="Replace Cancellation Policy"
                    busyLabel="Replacing..."
                    resultTitle="Cancellation Policy Response"
                    variant="warning"
                    confirm={{
                        title: 'Replace cancellation policy?',
                        message: 'This will replace the existing cancellation policy on VRBO for this property.',
                    }}
                />
            ) : (
                <VrboActionRow
                    action={cancellationPolicy}
                    label="Create Cancellation Policy"
                    busyLabel="Creating..."
                    resultTitle="Cancellation Policy Response"
                />
            )}
        </div>
    )
}
